import { useLocalization } from "../../context/LocalizeContextProvider";
import usePatientReservationValidation from "./usePatientReservationValidation";

export const useDepositPatientValidation = () => {
  const localize = useLocalization();
  const patientValidation = usePatientReservationValidation();

  const validate = (values, activeTab, selectedExistingPatient) => {
    const errors = {};

    if (!values.price) {
      errors.price = localize.getText("generalRequiredFieldValidation", {
        fieldName: localize.getText("price"),
      });
    }

    if (
      values.price &&
      (isNaN(values.price) || parseFloat(values.price) <= 0)
    ) {
      errors.price = localize.getText("priceGreaterThanZero");
    }

    if (!values.method) {
      errors.method = "Harap masukkan Metode Pembayaran";
    }

    const isCardNumber =
      values?.method === "CREDIT_CARD" || values?.method === "DEBIT";

    if (!values.cardNumber && isCardNumber) {
      errors.cardNumber = "Harap masukkan Nomor Kartu";
    }
    if (values?.cardNumber?.length < 16 && isCardNumber) {
      errors.cardNumber = "Harap masukkan 16 digit Nomor Kartu";
    }

    // Patient validation based on active tab
    if (activeTab === "1") {
      // Existing patient validation
      if (!selectedExistingPatient?.id) {
        errors.existingPatient = localize.getText(
          "pleaseSelectExistingPatient"
        );
      }
    } else if (activeTab === "2") {
      // New patient validation
      const patientErrors = patientValidation(values);
      Object.assign(errors, patientErrors);
    }

    return errors;
  };

  return validate;
};
